import React from "react";
import PropTypes from "prop-types";

const NumberCell = ({ value }) => (
  <div style={{ width: "100%", textAlign: "right" }}>{value}</div>
);

NumberCell.propTypes = {
  value: PropTypes.string
};

export default NumberCell;
